import * as React from 'react';
import {View} from 'react-native';
import {useSelector} from 'react-redux';
import {get} from 'lodash';

import ListItem from '/component/base/ListItem';
import {LoadingBox} from '/component/base/LoadingBox';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {useTranslation} from '/provider/TranslationProvider';
import {
  variablesBannerText,
  variablesFeatureFlag,
} from '/redux/selector/remoteConfig.selector';
import {shouldReleaseFeature} from '/util/featureRelease.util';

import {styles} from './Loading.style';

export const Loading = () => {
  const {tt} = useTranslation(
    'reportCardContent.eligibleClientSupportBonusPlus',
  );
  const featureFlag = useSelector(variablesFeatureFlag);
  const showEnhancedCSBPlus = get(featureFlag, 'showEnhancedCSBPlus', false);
  const featureFlagBannerText = useSelector(variablesBannerText);
  const CSBPlusDetails = featureFlagBannerText.CSBPlusDetails;
  const showCsbPlusInsightsFiltering = shouldReleaseFeature(
    get(featureFlag, 'ff_csb_plus_insights_filtering', ''),
  );

  const pqvText = showCsbPlusInsightsFiltering
    ? CSBPlusDetails.CSBPV5PQVText
    : showEnhancedCSBPlus
    ? CSBPlusDetails.newPQVText
    : CSBPlusDetails.origPQVText;

  const renderTitle = () => {
    return (
      <Text variant="caption" style={styles.boxTitle}>
        {tt('newClientsWith', pqvText)}
      </Text>
    );
  };
  return (
    <View style={styles.base}>
      <View style={styles.header}>
        <Gutter>
          <Text variant="heading">
            {tt('title', 'Eligible for Client Support Bonus+')}
          </Text>
        </Gutter>
      </View>
      <Gutter>
        <View style={styles.bonusProgressBar}>
          <View style={styles.bonusProgressBarSection}>
            <LoadingBox style={styles.loadingBoxDate} />
            <LoadingBox style={styles.loadingBoxProgressBarMoneyEarned} />
          </View>
          {renderTitle()}
          <LoadingBox style={styles.loadingBoxProgressBar} />
        </View>
      </Gutter>
      {!showEnhancedCSBPlus && !showCsbPlusInsightsFiltering && (
        <Gutter>
          <ListItem
            style={{base: styles.listItem}}
            readonly={true}
            label={<Text>{tt('eligible through', 'Eligible through')}</Text>}
            suffix={<LoadingBox style={styles.loadingBoxEligibleThrough} />}
          />
        </Gutter>
      )}
    </View>
  );
};
